var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurgerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.73 23.12",
    style: {
      enableBackground: "new 0 0 31.73 23.12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.5,3h28.73c0.83,0,1.5-0.67,1.5-1.5S31.06,0,30.23,0H1.5C0.67,0,0,0.67,0,1.5S0.67,3,1.5,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.23,13.06c0.83,0,1.5-0.67,1.5-1.5s-0.67-1.5-1.5-1.5H1.5c-0.83,0-1.5,0.67-1.5,1.5s0.67,1.5,1.5,1.5H30.23 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.23,20.12H1.5c-0.83,0-1.5,0.67-1.5,1.5s0.67,1.5,1.5,1.5h28.73c0.83,0,1.5-0.67,1.5-1.5 S31.06,20.12,30.23,20.12z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIcon);
export default __webpack_public_path__ + "static/media/burgerIcon.49a5f6f9.svg";
export { ForwardRef as ReactComponent };